import { useEffect,useState } from 'react';
import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import useIsFirstRender from '@/hooks/useIsFirstRender';
import useTranslations from '@/i18n/useTranslations';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import FormCheckbox from '@/shared-components/inputs/components/FormCheckbox';
import LimitedEditionPopup from '@/shared-components/popups/limited-edition';
import Text from '@/shared-components/text/components/Text';

import './styles/RequestLimitedEdition.css';

export default function RequestLimitedEdition({
  value,
  previewMode,
  unit,
  height,
  length,
  price,
  typeOfArtwork,
  onChange,
  approved,
  infoIcon = null,
  disabled = false,      // viene de permisos
}) {
  const t = useTranslations('common.forms.add_artwork');
  const [open, setOpen] = useState(false);
  const isFirstRender = useIsFirstRender();
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);

  useEffect(() => {
    if (!isFirstRender && value) {
      onChange(false);
    }
  }, [unit, height, length, price, typeOfArtwork]);

  const dataNeeded = { unit, height, length, price, typeOfArtwork };
  const missingData = !height || !length || !price;
  const isTotallyDisabled = disabled || missingData;

  // 1) Modo sólo lectura (preview)
  if (previewMode) {
    return (
      <div className="request-limited-edition__container">
        <LimitedEditionIcon className="request-limited-edition__limited-edition-icon" />
        <Text className="request-limited-edition__text">
          {value
            ? t('limited_editions.requested')
            : t('limited_editions.not_requested')}
          {infoIcon && (
            <InfoIconArtwork
              className="step-accordeon-step-header__info-icon"
              onClick={setIsInfoIconOpen}
              open={isInfoIconOpen}
              header={infoIcon.header || infoIcon.name}
              description={infoIcon.description}
            />
          )}
        </Text>
      </div>
    );
  }

  // 2) Gallery owned: no es elegible
  if (typeOfArtwork === "Gallery owned") {
    return (
      <div className="request-limited-edition__container disabled">
        <LimitedEditionIcon className="request-limited-edition__limited-edition-icon" />
        <Text className="request-limited-edition__gallery__text">
          {t('limited_editions.gallery_owned_not_eligible')}
          {infoIcon && (
            <InfoIconArtwork
              className="step-accordeon-step-header__info-icon"
              onClick={setIsInfoIconOpen}
              open={isInfoIconOpen}
              header={infoIcon.header || infoIcon.name}
              description={infoIcon.description}
            />
          )}
        </Text>
      </div>
    );
  }

  // 3) Si no hay datos o permisos: mostrar control DESHABILITADO
  if (isTotallyDisabled) {
    return (
      <div className="request-limited-edition__container disabled">
        <LimitedEditionIcon className="request-limited-edition__limited-edition-icon" />
        <Text className="request-limited-edition__text">
          {missingData
            ? t('limited_editions.missing_requirements')
            : t('limited_editions.permission_denied')}
          {infoIcon && (
            <InfoIconArtwork
              className="step-accordeon-step-header__info-icon"
              onClick={setIsInfoIconOpen}
              open={isInfoIconOpen}
              header={infoIcon.header || infoIcon.name}
              description={infoIcon.description}
            />
          )}
        </Text>
      </div>
    );
  }

  // 4) Caso interactivo: puede solicitar
  return (
    <>
      <div
        className="request-limited-edition__container element-non-selectable"
      >
        <div className="public-form-input__checkbox-container">
          <span onClick={() => setOpen(true)}>
            <FormCheckbox
              className="request-limited-edition__checkbox"
              element="artwork_limited_edition"
              readOnly={false}
              value={value}
              onChange={(_, e) => e.preventDefault()}
            />
          </span>

          <p className="public-form-input__checkbox-text element-non-selectable">
            <Text
              className="request-limited-edition__clickable-text"
              onClick={() => setOpen(true)}>
              {t('limited_editions.request')}
            </Text>
            <LimitedEditionIcon
              className="request-limited-edition__limited-edition-icon"
              onClick={() => setOpen(true)}
            />
            {infoIcon && (
              <InfoIconArtwork
                className="step-accordeon-step-header__info-icon"
                onClick={setIsInfoIconOpen}
                open={isInfoIconOpen}
                header={infoIcon.header || infoIcon.name}
                description={infoIcon.description}
              />
            )}
          </p>
        </div>
      </div>
      <LimitedEditionPopup
        requested={value}
        open={open}
        close={() => setOpen(false)}
        onRequest={() => {
          onChange(true);
          setOpen(false);
        }}
        dataNeeded={dataNeeded}
        approved={approved}
      />
    </>
  );
}
